import { Card, FormGroup } from "@cofano/cck";
import { Box, Grid2 as Grid, useTheme } from "@mui/material";
import { Language } from "imports/Utils";
import { SalesCharter, Voyage } from "types/index";
import { RelationLink, ShipLink } from "utils/LinkUtils";
import { FormattedDate } from "utils/DateUtils";
import { CharterSubtype, CharterType } from "__generated__/enums";

type SalesCharterInfoBlockProps = {
	charter: SalesCharter;
	voyage?: Voyage;
	color: string;
};

const SalesCharterInfoBlock = ({ charter, voyage, color }: SalesCharterInfoBlockProps) => {
	const theme = useTheme();
	return (
		<Box mb={1.5}>
			<Card color={color} disablePadding>
				<Box sx={{ backgroundColor: theme.palette.mode === "dark" ? "inherit" : "#EFEFEF", p: 1.5 }}>
					<Grid container spacing={3}>
						<Grid size={2}>
							<FormGroup label={Language("CHARTER")} labelPlacement="left-center" overflow="hidden">
								{charter.charterNumber}
							</FormGroup>
						</Grid>

						<Grid size={3}>
							<FormGroup label={Language("CONTRACTOR")} labelPlacement="left-center" overflow="hidden">
								<RelationLink relation={charter.creditor} />
							</FormGroup>

							{charter.type === CharterType.Sales && charter.subtype === CharterSubtype.Spot && charter.broker && (
								<FormGroup label={Language("BROKER")} labelPlacement="left-center" overflow="hidden">
									<RelationLink relation={charter.broker} />
								</FormGroup>
							)}
						</Grid>

						<Grid size={3}>
							<FormGroup label={Language("CUSTOMER")} labelPlacement="left-center" overflow="hidden">
								<RelationLink relation={charter.debtor} />
							</FormGroup>
						</Grid>

						<Grid size={4}>
							{voyage?.ship && (
								<FormGroup label={Language("SHIP")} labelPlacement="left-center" overflow="hidden">
									<ShipLink ship={voyage.ship} />
								</FormGroup>
							)}

							{charter.type === CharterType.Sales && charter.subtype === CharterSubtype.Spot && (
								<FormGroup label={Language("CARGO_CHARTER_FIRST_PLANNED_LOADING_DATE")} labelPlacement="left-center">
									<FormattedDate date={charter.firstLoadingDate} format="ll" />
								</FormGroup>
							)}
						</Grid>
					</Grid>
				</Box>
			</Card>
		</Box>
	);
};

export default SalesCharterInfoBlock;
